import React from "react";

export default function ParvandeIcon() {
  return (
    <svg
      width="57"
      height="70"
      viewBox="0 0 57 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 0.166687C17.2511 0.166687 15.8333 1.58447 15.8333 3.33335C15.8333 5.08224 17.2511 6.50002 19 6.50002H38C39.749 6.50002 41.1667 5.08224 41.1667 3.33335C41.1667 1.58447 39.749 0.166687 38 0.166687H19ZM9.63025 4.91007C9.48616 4.04756 8.79111 3.33335 7.91667 3.33335H6.33333C2.83553 3.33335 0 6.16888 0 9.66669V63.5C0 66.9979 2.83553 69.8334 6.33333 69.8334H50.6667C54.1646 69.8334 57 66.9979 57 63.5V9.66669C57 6.16888 54.1646 3.33335 50.6667 3.33335H49.0833C48.209 3.33335 47.5139 4.04756 47.3699 4.91007C46.6187 9.40636 42.7095 12.8334 38 12.8334H19C14.2904 12.8334 10.3813 9.40636 9.63025 4.91007ZM33.25 27.0834C33.25 26.209 32.541 25.5001 31.6667 25.5001L25.3333 25.5C24.4587 25.5 23.75 26.2089 23.75 27.0834V35.0003H15.8333C14.9589 35.0003 14.25 35.709 14.25 36.5837V42.917C14.25 43.7913 14.9589 44.5003 15.8333 44.5003H23.75V52.4167C23.75 53.291 24.459 54 25.3333 54H31.6667C32.541 54 33.25 53.291 33.25 52.4167V44.5003L41.1667 44.5C42.041 44.5 42.75 43.7913 42.75 42.9167V36.5837C42.75 35.709 42.041 35.0003 41.1667 35.0003H33.25V27.0834Z"
        fill="#42C3CF"
      />
    </svg>
  );
}
